import React, { useEffect, useRef, useState } from "react";
import SoftBox from "components/SoftBox";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";
import "./accountDetailTabs.css";

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const normalizeBusinessHours = (hours) =>
  DAYS.map((day) => {
    const entry = (hours || []).find((bh) => bh.day === day);
    return {
      day,
      start_time: entry?.start_time || "",
      end_time: entry?.end_time || "",
    };
  });

function BusinessHours({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [businessHours, setBusinessHours] = useState([]);
  const formDataRef = useRef(formData);
  const businessHoursRef = useRef(businessHours);

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    businessHoursRef.current = businessHours;
  }, [businessHours]);

  useEffect(() => {
    setBusinessHours(normalizeBusinessHours(formData?.business_hours));
  }, [formData]);

  const persistBusinessHours = async (hours, successMessage = "Business hours saved") => {
    const accountId = formDataRef.current?.id;
    if (!accountId) {
      toast.error("Business account not found");
      return false;
    }

    try {
      const { response, error } = await AppService.accounts.update({
        payload: { _id: accountId, business_hours: hours },
      });
      if (error || response?.success === false) {
        toast.error(error?.message || response?.message || "Failed to save business hours");
        return false;
      }
      await handleRefresh?.();
      toast.success(successMessage);
      return true;
    } catch (err) {
      console.error("Business hours save failed:", err);
      toast.error("Failed to save business hours");
      return false;
    }
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    setBusinessHours((prevData) => {
      const next = prevData.map((entry, i) =>
        i === index ? { ...entry, [name]: value } : entry
      );
      businessHoursRef.current = next;
      return next;
    });
  };

  const handleTimeBlur = () => {
    const nextHours = businessHoursRef.current;
    const savedHours = normalizeBusinessHours(formDataRef.current?.business_hours);
    if (JSON.stringify(nextHours) === JSON.stringify(savedHours)) return;
    persistBusinessHours(nextHours);
  };

  return (
    <div className="sd-account-detail-tab">
      <div>
        {businessHours.map((entry, index) => (
          <div style={{ display: "flex", width: "100%" }} key={entry.day}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Day</label>
                <input
                  className="form-control-agust"
                  value={entry.day}
                  readOnly
                  style={{ backgroundColor: "#f5f5f5" }}
                />
              </SoftBox>
            </div>
            <div style={{ width: "25%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Start Time</label>
                <input
                  className="form-control-agust"
                  onChange={(e) => handleChange(e, index)}
                  onBlur={handleTimeBlur}
                  placeholder="Start Time"
                  name="start_time"
                  type="time"
                  value={entry.start_time}
                />
              </SoftBox>
            </div>
            <div style={{ width: "25%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">End Time</label>
                <input
                  className="form-control-agust"
                  onChange={(e) => handleChange(e, index)}
                  onBlur={handleTimeBlur}
                  placeholder="End Time"
                  name="end_time"
                  type="time"
                  value={entry.end_time}
                />
              </SoftBox>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BusinessHours;
